import { ColorModeScript } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from 'src/i18n';
import UiThemeProvider from 'src/shared-hold/theme/chakra/providers/UiThemeProvider/UiThemeProvider';
import ReactQueryClientProvider from 'src/shared-hold/reactQuery/providers/ReactQueryClientProvider';

function getRouterBasename() {
  const configuredBasename = process.env.REACT_APP_ROUTER_BASENAME || process.env.PUBLIC_URL || '';

  if (!configuredBasename || configuredBasename === '/') {
    return undefined;
  }

  if (/^https?:\/\//i.test(configuredBasename)) {
    return undefined;
  }

  return configuredBasename;
}

const SharedModule: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  // Translate Provider
  <I18nProvider>
    {/* // Router controller for web */}
    <BrowserRouter basename={getRouterBasename()}>
      {/* // UiTheme provider from the UiPackage */}
      <UiThemeProvider>
        {/* React query provider */}
        <ReactQueryClientProvider>{children}</ReactQueryClientProvider>
      </UiThemeProvider>
      <ColorModeScript />
    </BrowserRouter>
  </I18nProvider>
);

export default SharedModule;
